"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationJsonSanitizer = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const Configuration_1 = require("./Configuration");
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
const echain_shared_logging_1 = require("@igus/echain-shared-logging");
class ConfigurationJsonSanitizer {
    /**
     * Performs a sanity check and removes articles that depend on non existing articles.
     * If no Leitungen have been configured, then the Konfektionierung is removed.
     * If no Kette has been configured, then all articles except Leitungen are removed. The Leitung IA
     * Positions are also removed. If no AEs have been configured, then the Zugentlastung, Verpackung,
     * Konfektionierung, Fuehrungsrinne and Montage Sets are removed. Please note that the triple
     * Leitungen, Kette and AEs represents the minimal configuration. If no Verpackung has been
     * configured, then the Konfektionierung is removed. If no Fuehrungsrinne has been configured,
     * then the Montage Sets are removed.
     *
     * @param configurationJson The given configuration
     * @returns A new configuration with invalid parts removed
     */
    static transformToValidConfiguration(configurationJson) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const result = (0, echain_shared_ts_utils_1.clonePrimitive)(configurationJson);
        // manual mode flow does not have these kind of validations
        if (result.ManagedConfigurationType !== echain_shared_configurations_1.ManagedConfigurationType.IQuote && result.IsManualMode) {
            return result;
        }
        const configModel = Configuration_1.Configuration.fromJson(configurationJson).toModel();
        if (!(0, echain_shared_configurations_1.isConfigurationUnion)(configModel)) {
            (0, echain_shared_logging_1.getLogger)().warn(`${this.className}.transformToValidConfiguration(): !isConfigurationUnion(configModel)`);
            return Object.assign(Object.assign({}, Configuration_1.Configuration.fromScratch().toJson()), { ManagedConfigurationType: result.ManagedConfigurationType, ConfigurationStartedWith: result.ConfigurationStartedWith, IsManualMode: result.IsManualMode, Leitungen: ((_a = result.Leitungen) === null || _a === void 0 ? void 0 : _a.map((l) => (Object.assign(Object.assign({}, l), { LocalTransform: undefined })))) || [] });
        }
        const hasRealLeitungen = ((_c = (_b = configModel.Leitungen) === null || _b === void 0 ? void 0 : _b.filter((l) => !l.IsPlaceholder).length) !== null && _c !== void 0 ? _c : 0) > 0;
        if (!hasRealLeitungen) {
            result.Konfektionierungen = [];
            result.CustomKonfektionierungPrice = undefined;
        }
        const { type } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configModel);
        switch (type) {
            case 'Empty':
                result.AEs = [];
                result.IAs = [];
                result.Zugentlastungen = [];
                result.Verpackungen = [];
                result.Konfektionierungen = [];
                result.CustomKonfektionierungPrice = undefined;
                result.Fuehrungsrinnen = [];
                result.MontageSets = [];
                result.MontBes = [];
                // no kette, no position!
                (_d = result.Leitungen) === null || _d === void 0 ? void 0 : _d.forEach((l) => (l.LocalTransform = undefined));
                break;
            case 'Espool':
            case 'EspoolChild':
            case 'Kette':
                break;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
        const hasAEs = ((_f = (_e = configModel.AEs) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0;
        if (!hasAEs) {
            result.Zugentlastungen = [];
            result.Verpackungen = [];
            result.Konfektionierungen = [];
            result.CustomKonfektionierungPrice = undefined;
            result.Fuehrungsrinnen = [];
            result.MontageSets = [];
            result.MontBes = [];
        }
        const hasVerpackungen = ((_h = (_g = configModel.Verpackungen) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0) > 0;
        if (!hasVerpackungen) {
            result.Konfektionierungen = [];
            result.CustomKonfektionierungPrice = undefined;
        }
        const hasFuehrungsrinnen = ((_k = (_j = configModel.Fuehrungsrinnen) === null || _j === void 0 ? void 0 : _j.length) !== null && _k !== void 0 ? _k : 0) > 0;
        if (!hasFuehrungsrinnen) {
            // in iQuote it is valid to have Montageset without Fuehrungsrinne
            if (configModel.ManagedConfigurationType !== echain_shared_configurations_1.ManagedConfigurationType.IQuote) {
                result.MontageSets = [];
            }
        }
        return result;
    }
}
exports.ConfigurationJsonSanitizer = ConfigurationJsonSanitizer;
ConfigurationJsonSanitizer.className = 'ConfigurationJsonSanitizer';
//# sourceMappingURL=ConfigurationJsonSanitizer.js.map